<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="rounded-lg">
          <v-tabs v-model="activeTab" color="primary" fixed-tabs icons-and-text>
            <v-tab>
              {{ tabs.group.label }}
              <v-icon class="ml-2" size="18">{{ tabs.group.icon }}</v-icon>
            </v-tab>

            <v-tab>
              {{ tabs.paper_edit.label }}
              <v-icon class="ml-2" size="18">{{ tabs.paper_edit.icon }}</v-icon>
            </v-tab>

            <v-tab>
              {{ tabs.page.label }}
              <v-icon class="ml-2" size="18">{{ tabs.page.icon }}</v-icon>
            </v-tab>

            <v-tab>
              {{ tabs.page_v2.label }}
              <v-icon class="ml-2" size="18">{{ tabs.page_v2.icon }}</v-icon>
            </v-tab>

            <v-tab>
              {{ tabs.final_check.label }}
              <v-icon class="ml-2" size="18">{{ tabs.final_check.icon }}</v-icon>
            </v-tab>

            <!-- 백커버 탭 - 논문편집 탭에서 동일 기능 제공으로 주석 처리
            <v-tab>
              {{ tabs.backcover.label }}
              <v-icon class="ml-2" size="18">{{ tabs.backcover.icon }}</v-icon>
            </v-tab>
            -->
          </v-tabs>

          <v-tabs-items v-model="activeTab">
            <v-tab-item>
              <edit-journal-content-group
                :journal_idx="idx"
              ></edit-journal-content-group>
            </v-tab-item>

            <v-tab-item>
              <edit-group-papers :journal_idx="idx"></edit-group-papers>
            </v-tab-item>

            <v-tab-item>
              <edit-paper-pages
                :key="`page-${refreshKey}`"
                :journal_idx="idx"
              ></edit-paper-pages>
            </v-tab-item>

            <v-tab-item>
              <edit-paper-pages-v2
                :key="`page-v2-${refreshKey}`"
                :journal_idx="idx"
              ></edit-paper-pages-v2>
            </v-tab-item>

            <v-tab-item>
              <show-final-journal-content
                :journal_idx="idx"
              ></show-final-journal-content>
            </v-tab-item>

            <!-- 백커버 탭 콘텐츠 - 논문편집 탭에서 동일 기능 제공으로 주석 처리
            <v-tab-item>
              <edit-backcover-info
                :journal_idx="idx"
              ></edit-backcover-info>
            </v-tab-item>
            -->
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EditJournalContentGroup from "@/views/JournalView/EditJournalContentGroup.vue";
import EditPaperPages from "@/views/JournalView/EditPaperPages.vue";
import EditPaperPagesV2 from "@/views/JournalView/EditPaperPagesV2.vue";
import ShowFinalJournalContent from "@/views/JournalView/ShowFinalJournalContent.vue";
import EditGroupPapers from "@/views/JournalView/EditGroupPapers.vue";
// import EditBackcoverInfo from "@/views/JournalView/EditBackcoverInfo.vue"; // 논문편집 탭에서 동일 기능 제공

import { journalContentTabs } from "@/fields/journal/tabs";

export default {
  components: {
    EditJournalContentGroup,
    EditPaperPages,
    EditPaperPagesV2,
    ShowFinalJournalContent,
    EditGroupPapers,
    // EditBackcoverInfo, // 논문편집 탭에서 동일 기능 제공
  },
  props: {
    idx: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      activeTab: 0,
      tabs: journalContentTabs,
      refreshKey: 0,
    };
  },
  watch: {
    activeTab() {
      // 탭 전환 시 페이지 편집 관련 컴포넌트 새로고침
      this.refreshKey++;
    },
  },
};
</script>
